<template>
  <section id="LiveStream" class="g_section pt-0">
    <div class="g_frame livestream">
      <div class="thumbnail">
        <div class="end">
          <img src="../../assets/img_livestream_thumbnail.png" alt="" />
        </div>
      </div>
      <div class="texts">
        <h3>
          会場の様子を徹底生中継！<br />
          番組ページはこちら
        </h3>
        <ul>
          <li>
            <a
              href="https://live2.nicovideo.jp/watch/lv325470674"
              target="_blank"
              class="nicolive"
              ><img src="../../assets/img_nicolive.png" alt="ニコニコ生放送"
            /></a>
          </li>
          <li>
            <a
              href="https://youtu.be/mSRbfbdK2Po"
              target="_blank"
              class="youtube"
              ><img src="../../assets/img_youtube.png" alt="YouTube"
            /></a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LiveStream"
};
</script>

<style scoped>
.livestream {
  display: flex;
  padding: 0;
}
.texts {
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.texts h3 {
  font-size: 2rem;
  font-weight: 900;
  margin: 0.2rem 0 1rem;
  line-height: 1.2;
  font-feature-settings: "palt";
}
.texts ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}
.texts li {
  margin: 0 32px 0 0;
  padding: 0;
}
.nicolive {
  width: 172px;
  display: inline-block;
}
.youtube {
  width: 134px;
  display: inline-block;
}
.nicolive img,
.youtube img {
  width: 100%;
}
.thumbnail .end {
  width: 100%;
  position: relative;
  line-height: 1;
}
.thumbnail .end:before {
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  content: "";
  display: block;
  position: absolute;
  z-index: 1;
  background: rgba(0, 0, 0, 0.25);
}
.thumbnail .end:after {
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  content: "終了しました";
  font-weight: 900;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 2;
  background: rgba(0, 0, 0, 0.25);
}
@media screen and (max-width: 980px) {
  .thumbnail {
    width: 45%;
  }
  .thumbnail img {
    width: 100%;
  }
  .texts {
    width: 55%;
    padding: 5%;
    box-sizing: border-box;
  }
  .texts h3 {
    font-size: 3vw;
  }
  .nicolive {
    width: 100%;
  }
  .youtube {
    width: 100%;
  }
}
@media screen and (max-width: 568px) {
  .livestream {
    flex-direction: column;
  }
  .thumbnail {
    width: 100%;
  }
  .texts {
    width: 100%;
  }
  .texts h3 {
    font-size: 6vw;
    text-align: center;
  }
  .texts li {
    margin: 0 4%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/TheLiveStreamSection.vue